import React, { useState } from 'react';
import { Section, CTAButton } from './ui';
import { Star, ChevronDown, Lock, CreditCard } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Posta pensé que backtestear era mirar el gráfico y marcar dónde hubiese entrado. Con esto entendí que lo estaba haciendo re desordenado.',
    author: 'Martín S.'
  }, {
    quote: 'Me sirvió mucho porque yo cambiaba de estrategia cada vez que perdía dos operaciones seguidas. Ahora entiendo que primero tengo que medir antes de descartar.',
    author: 'Lucas G.'
  }, {
    quote: 'Lo leí y al toque me puse a armar mis reglas. Me di cuenta de que tenía la estrategia en la cabeza, pero no sabía explicarla bien.',
    author: 'Diego M.'
  }, {
    quote: 'Me gustó que va directo al punto. No es puro humo de trading, te dice qué mirar, qué anotar y cómo empezar.',
    author: 'Federico R.'
  }, {
    quote: 'Me pasó mil veces de cerrar antes por miedo. La parte de emociones me hizo dar cuenta de que el problema no era solo la entrada, era cómo la gestionaba.',
    author: 'Tomás A.'
  }, {
    quote: 'Muy claro. Me ayudó a entender qué datos registrar y a no contar como válida cualquier operación que después salió bien.',
    author: 'Nicolás P.'
  }];
  return <Section data-id="element-78">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-79">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-80">
          Traders que dejaron de improvisar
        </h2>
        <p className="text-xl text-gray-400" data-id="element-81">
          Lectores aplicando el backtesting para operar con reglas, datos y un
          plan claro.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-82">
        {testimonials.map((t, idx) => <div key={idx} className="bg-dark-card border border-dark-border p-6 rounded-xl flex flex-col h-full" data-id="element-83">
            <div className="flex gap-1 mb-4" data-id="element-84">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-amber-500 text-amber-500" data-id="element-85" />)}
            </div>
            <p className="text-gray-300 mb-6 flex-grow italic" data-id="element-86">"{t.quote}"</p>
            <div className="flex items-center gap-3 mt-auto" data-id="element-87">
              <div className="w-10 h-10 rounded-full bg-dark-border flex items-center justify-center text-gray-400 font-bold" data-id="element-88">
                {t.author.charAt(0)}
              </div>
              <p className="font-bold text-white" data-id="element-89">{t.author}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}
export function Offer() {
  return <Section darker id="oferta" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <div className="bg-gradient-to-b from-dark-card to-dark-bg border-2 border-brand-500 rounded-3xl p-8 md:p-12 text-center relative shadow-[0_0_50px_rgba(16,185,129,0.15)]" data-id="element-92">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-500 text-white px-6 py-2 rounded-full font-bold text-sm tracking-wider uppercase shadow-lg" data-id="element-93">
            Oferta Especial
          </div>

          <h2 className="text-3xl md:text-5xl font-heading font-black text-white mb-6 mt-4" data-id="element-94">
            Empezá a medir tus operaciones hoy
          </h2>

          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-95">
            Accedé a La Biblia del Backtest + El Plan de 7 Días y dejá de operar
            desde la duda.
          </p>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-96">
            <p className="text-gray-500 line-through text-2xl mb-2" data-id="element-97">
              Precio regular: $1.999
            </p>
            <div className="flex items-start justify-center text-brand-400" data-id="element-98">
              <span className="text-4xl font-bold mt-2" data-id="element-99">$</span>
              <span className="text-7xl md:text-8xl font-black tracking-tighter" data-id="element-100">
                999
              </span>
            </div>
            <p className="text-amber-500 font-medium mt-4" data-id="element-101">
              Menos que una mala entrada. Más claridad antes de volver a
              arriesgar.
            </p>
          </div>

          <CTAButton size="xl" className="w-full md:w-auto md:min-w-[400px]" data-id="element-102">
            Comprar Ahora por $999
          </CTAButton>

          <div className="mt-8 flex flex-col items-center gap-4 text-gray-400 text-sm" data-id="element-103">
            <div className="flex items-center gap-6" data-id="element-104">
              <div className="flex items-center gap-2" data-id="element-105">
                <Lock className="w-4 h-4" data-id="element-106" /> Pago Seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-107">
                <CreditCard className="w-4 h-4" data-id="element-108" /> Tarjetas / MercadoPago
              </div>
            </div>
            <p data-id="element-109">Acceso inmediato al ebook digital tras el pago.</p>
          </div>
        </div>
      </div>
    </Section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Cuándo recibo el producto?',
    a: 'Recibís el acceso a La Biblia del Backtest inmediatamente después de realizar la compra, para que puedas empezar a leerlo y aplicarlo en el momento.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No necesitás ser experto, pero sí es ideal que ya tengas una estrategia o una idea de estrategia que quieras ordenar, medir y validar con backtesting.'
  }, {
    q: '¿En qué formato viene?',
    a: 'Viene en formato ebook digital (PDF), para que puedas leerlo desde tu celular, computadora o tablet en cualquier momento.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días de garantía para revisar el contenido y comprobar si te ayuda a entender cómo hacer backtesting de forma más clara, objetiva y ordenada. Si no es lo que esperabas, te devolvemos el dinero.'
  }];
  return <Section data-id="element-110">
      <div className="max-w-3xl mx-auto" data-id="element-111">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white text-center mb-12" data-id="element-112">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-113">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-114" />)}
        </div>
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-dark-card border border-dark-border rounded-xl overflow-hidden" data-id="element-115">
      <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-116">
        <span className="font-bold text-white text-lg" data-id="element-117">{question}</span>
        <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-118" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-119">
        <p className="text-gray-400" data-id="element-120">{answer}</p>
      </div>
    </div>;
}
export function FinalCTA() {
  return <Section darker className="border-t border-dark-border" data-id="element-121">
      <div className="text-center max-w-3xl mx-auto" data-id="element-122">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-123">
          ¿Vas a seguir operando a ciegas?
        </h2>
        <p className="text-xl text-gray-400 mb-10" data-id="element-124">
          El mercado no perdona la falta de preparación. Empezá a validar tu
          estrategia hoy y tomá el control de tus operaciones.
        </p>
        <CTAButton size="xl" data-id="element-125">Sí, quiero validar mi estrategia</CTAButton>
      </div>
    </Section>;
}